import {UIGameManager} from '../UIGameManager'
import {UIGameDiceController} from './UIGameDiceController'
import {MechanicEventDiceState} from '@colonist/game-states'

export abstract class UIGameBaseDiceController extends UIGameDiceController {
    protected readonly isRedDiceActive: boolean

    constructor(uiGameManager: UIGameManager, eventDiceState: MechanicEventDiceState | undefined) {
        super(uiGameManager)

        this.isRedDiceActive = eventDiceState !== undefined
        this.initializeOpponentDiceViews()
        this.initializeCurrentTurnPlayer()
        this.updateDiceImage()
        this.updateDiceView()
    }
}
